import { useCallback, useRef } from "react";

/**
 * BİR KOMUT DENEMESİ İÇİN KARARLI `Idempotency-Key` (BUG-004 · Mega E2E).
 *
 * ### ⚠ BAŞLIĞIN VARLIĞI KORUMA DEĞİL
 *
 * Ölçüldü: 174 mutasyon çağrısının 25'i başlığı gönderiyordu, ama hepsi anahtarı
 * `mutationFn` İÇİNDE üretiyordu (`headers: { "idempotency-key": crypto.randomUUID() }`).
 * Her çağrı yeni anahtar demek: kullanıcı iki kez tıkladığında sunucu iki FARKLI anahtar
 * görüyor, ikisini de kabul ediyor ve iki kayıt doğuyor. Yani koruma adı vardı kendi
 * yoktu — üstelik çağrı yerlerindeki yorumlar "çift tıklama iki davet yazmasın" diye
 * yazıyordu.
 *
 * Sunucu tarafı zaten doğru: `idempotency()` aynı anahtarı ikinci kez gördüğünde ilk
 * yanıtı tekrar veriyor. Eksik olan tek şey, İSTEMCİNİN aynı niyeti aynı anahtarla
 * göndermesiydi.
 *
 * ### ⚠ ANAHTAR NİYETE BAĞLI, TIKLAMAYA DEĞİL
 *
 * `uret()` anahtarı bir kez üretip SAKLIYOR: aynı kullanıcı niyetinin her denemesi —
 * çift tıklama, ağ hatası sonrası yeniden deneme — aynı anahtarı taşıyor. Başarıdan sonra
 * `yenile()` çağrılıyor ve bir SONRAKİ niyet yeni bir anahtar alıyor; yenilemeseydik
 * kullanıcı ikinci kez bilerek davet gönderdiğinde sunucu onu replay sayıp sessizce ilk
 * yanıtı döndürürdü.
 *
 * ### ⚠ HER İSTEĞE BASILMIYOR
 *
 * Kapsam sunucudan türüyor: yalnız `idempotency()` zinciriyle korunan uçlar. Başlığı her
 * isteğe basmak, idempotent OLMAYAN bir uçta kullanıcının bilinçli tekrarını sessizce
 * yutabilirdi.
 */
export function useIdempotencyKey(): { uret: () => string; yenile: () => void } {
  const anahtar = useRef<string | null>(null);

  const uret = useCallback(() => {
    anahtar.current ??= crypto.randomUUID();
    return anahtar.current;
  }, []);

  const yenile = useCallback(() => {
    anahtar.current = null;
  }, []);

  return { uret, yenile };
}
